import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 56px 20px 40px 20px;

        & > img {
            width: 240px;
        }
    `,
    "Title": styled.h2`
        ${({ theme }) => theme.font["xlarge-semibold"]};
    `,
    "Content": styled.p`
        ${({ theme }) => theme.font["medium-regular"]};
    `,
}